import React from 'react';
import { addQueryParam } from '../../utils/HttpUtils';
import { I18n } from 'react-redux-i18n-lite';
import azure_icon from '../../images/azure_icon.png';
import PropTypes from 'prop-types';

export default class LoginAzure extends React.Component {
  static propTypes = {
    redirectUrl: PropTypes.string
  };

  onClick = () => {
    window.location.href = addQueryParam(this.props.redirectUrl, 'ssoWith', 'azure');
  };

  render() {
    return (
      <button onClick={this.onClick} className="sso-login">
        <img src={azure_icon} alt="presentation" />
        <span>{I18n.t('login.azureLogin')}</span>
      </button>
    );
  }
}
